import React from 'react';
import classes from './CheckBox.module.css'

function CheckBox({onChange, defaultChecked, value}) {
  return (
    <input className={classes.checkBox} checked={value} defaultChecked={defaultChecked} type="checkbox" id="confirmDetails" onChange={(e) => onChange(e)} />
  )
}

export default CheckBox